import { EMAIL_CHANGED, NEXT_STEP } from './constants'

export const emailChanged = (email) => {
  return {
    type: EMAIL_CHANGED,
    email
  }
}


export const nextStep = () => {
  return {
    type: NEXT_STEP
  }
}



// WEBPACK FOOTER //
// ./src/scenes/PasswordRecovery/actions.js